import { Directive, OnDestroy, OnInit } from '@angular/core';
import { CustomComponent } from '@cakeiteasy/web-utils';

@Directive({ standalone: false })
export abstract class MobileBaseOrderProcessComponent extends CustomComponent implements OnInit, OnDestroy {
  private _mobileBodyCssClass = 'op-mobile-body';

  ngOnInit() {
    if (document && document.body) {
      document.body.classList.add(this._mobileBodyCssClass);
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (document && document.body) {
      document.body.classList.remove(this._mobileBodyCssClass);
    }
  }
}
